export function isValidUrl (storeUrl) {
  let url
  try {
    url = new URL(storeUrl)
  } catch (_) {
    return false
  }
  return url.protocol === 'http:' || url.protocol === 'https:'
}
